import React, { useState } from "react";
import { Button, Spinner } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faListAlt,
  faRedo,
  faTasks,
} from "@fortawesome/free-solid-svg-icons";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { createRewardCalcJob } from "../controller/api/rewardCalcJob";
import { Routes } from "../routes";

const REWARD_CALCULATED_RESULT_STATUS = 2;

export const isRewardCalculated = (
  status,
  totalTickets,
  totalRewaredTickets = 0,
  totalUnRewardTickets = 0
) =>
  status === REWARD_CALCULATED_RESULT_STATUS ||
  (totalTickets != null && Number(totalTickets) !== 0) ||
  Number(totalRewaredTickets) + Number(totalUnRewardTickets) > 0;

const getCalculatedState = ({
  status,
  totalTickets,
  totalRewaredTickets,
  totalUnRewardTickets,
}) =>
  isRewardCalculated(
    status,
    totalTickets,
    totalRewaredTickets,
    totalUnRewardTickets
  );

const RewardCalcStatusCell = (props) => {
  const isCalculated = getCalculatedState(props);

  return (
    <td className="text-center">
      {isCalculated ? (
        <span className="d-inline-flex align-items-center text-success fw-bold text-nowrap">
          <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
          Đã tính thưởng
        </span>
      ) : (
        <span className="text-muted text-nowrap">Chưa tính thưởng</span>
      )}
    </td>
  );
};

export const RewardCalcActionsCell = ({
  gameId,
  gamePeriodId,
  status,
  totalTickets,
  totalRewaredTickets,
  totalUnRewardTickets,
  onConfirmNumberTicket,
  onCalculateReward,
}) => {
  const [cookies] = useCookies(["lottmekong"]);
  const [creating, setCreating] = useState(false);

  const isCalculated = getCalculatedState({
    status,
    totalTickets,
    totalRewaredTickets,
    totalUnRewardTickets,
  });
  const viewJobButton = (
    <Button
      as={Link}
      to={`${Routes.VietlottRewardCalcJob.path}?gameId=${encodeURIComponent(
        gameId
      )}&period=${encodeURIComponent(gamePeriodId)}`}
      variant="outline-info"
      size="sm"
      className="px-3 text-decoration-none text-nowrap"
    >
      <FontAwesomeIcon icon={faTasks} className="me-2" />
      Xem Job
    </Button>
  );
  const onRecalculate = async () => {
    setCreating(true);
    try {
      const response = await createRewardCalcJob(
        cookies.lottmekong,
        gameId,
        gamePeriodId
      );
      if (response && response.status === 1) {
        toast.success(
          `Đã tạo job tính lại cho kỳ ${gamePeriodId}, xem tiến trình ở trang Job tính thưởng`
        );
      } else {
        toast.error(response?.message || "Không thể tạo job tính lại");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Không thể tạo job tính lại"
      );
    } finally {
      setCreating(false);
    }
  };

  if (!isCalculated) {
    return (
      <td className="text-center">
        <div className="d-flex justify-content-center align-items-center flex-nowrap gap-2">
          {onCalculateReward && (
            <Button
              variant="primary"
              size="sm"
              className="px-3 text-nowrap"
              onClick={onCalculateReward}
            >
              Tính thưởng
            </Button>
          )}
          <Button
            variant="outline-secondary"
            size="sm"
            className="px-3 text-nowrap"
            onClick={() =>
              onConfirmNumberTicket(
                gamePeriodId,
                totalRewaredTickets + totalUnRewardTickets === 0
                  ? -1
                  : totalRewaredTickets + totalUnRewardTickets
              )
            }
          >
            Không có vé
          </Button>
          {viewJobButton}
        </div>
      </td>
    );
  }

  return (
    <td className="text-center">
      <div className="d-flex justify-content-center align-items-center flex-nowrap gap-2">
        <Button
          as={Link}
          to={`${Routes.VietlottTicket.path}?gamePeriodId=${encodeURIComponent(
            gamePeriodId
          )}&statusGroup=done`}
          variant="primary"
          size="sm"
          className="px-3 text-decoration-none text-nowrap"
        >
          <FontAwesomeIcon icon={faListAlt} className="me-2" />
          Xem vé
        </Button>
        <Button
          variant="light"
          size="sm"
          className="px-3 border text-nowrap"
          onClick={onRecalculate}
          disabled={creating}
        >
          {creating ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <>
              <FontAwesomeIcon icon={faRedo} className="me-2" />
              Tính lại
            </>
          )}
        </Button>
        {viewJobButton}
      </div>
    </td>
  );
};

export default RewardCalcStatusCell;
